// "Talk to an HVAC engineer": a band that sends people to /hvac-consultant.
// Used on the homepage (after Our Services) and the VRV page. Prices come
// from src/data/consultation.js, the same file the payment is priced from.

import { Link } from 'react-router-dom';
import { CONSULT_SERVICES } from '../data/consultation';
import { formatINR } from '../lib/quote';

const rate = (r) => `₹${r % 1 ? r.toFixed(2) : r}`;

function Price({ s }) {
  if (s.price != null) {
    return <>{s.was && <s className="mr-1.5 text-xs font-medium text-gray-500">{formatINR(s.was)}</s>}{formatINR(s.price)}</>;
  }
  if (s.rate != null) {
    return <>{s.wasRate && <s className="mr-1.5 text-xs font-medium text-gray-500">{rate(s.wasRate)}</s>}{rate(s.rate)}<span className="text-xs font-semibold text-gray-600">/sq ft</span></>;
  }
  return <>{rate(s.rates.home)}–{s.rates.commercial}<span className="text-xs font-semibold text-gray-600">/sq ft</span></>;
}

export default function ConsultBand({ from = '', className = '' }) {
  const q = from ? `from=${from}` : '';
  return (
    <div className={`rounded-2xl border border-blue-200 bg-blue-50 p-5 text-left sm:p-6 ${className}`}>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-xl">
          <p className="text-[11px] font-bold tracking-[0.15em] text-blue-700">HVAC DESIGN</p>
          <h2 className="mt-1 text-xl font-bold text-gray-900 sm:text-2xl">Not sure what you need? Talk to an HVAC engineer.</h2>
          <p className="mt-1.5 text-sm text-gray-700">Fee adjusted against your order. Prices include GST.</p>
        </div>
        <Link to={`/hvac-consultant${q ? `?${q}` : ''}`}
          className="inline-flex h-12 shrink-0 items-center justify-center rounded-xl bg-blue-700 px-6 text-[15px] font-bold text-white hover:bg-blue-800">
          See options
        </Link>
      </div>
      <ul className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {CONSULT_SERVICES.map((s) => (
          <li key={s.id}>
            <Link to={`/hvac-consultant?service=${s.id}${q ? `&${q}` : ''}`}
              className="flex h-full items-baseline justify-between gap-2 rounded-xl bg-white px-3.5 py-3 ring-1 ring-blue-100 hover:ring-blue-300">
              <span className="text-sm font-semibold text-gray-900">{s.name}</span>
              <span className="shrink-0 whitespace-nowrap text-sm font-extrabold text-gray-900"><Price s={s} /></span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
